import { IAddress, IPersonalInfo } from 'interfaces/i-api-loan'
import React from 'react'

interface IUserAddressInfo {
	personalInfo: IPersonalInfo
	address: IAddress
	title: string
	isEstonianMarket: boolean
}

const UserAddressInfo = ({
	personalInfo,
	address,
	title,
	isEstonianMarket,
}: IUserAddressInfo) => {
	return (
		<>
			<p>
				<b>{title}: </b>
			</p>
			<p className="d-inline text-user-page">
				{personalInfo.firstName} {personalInfo.lastName}
				<br />
				{address.street}
				<br />
				{isEstonianMarket ? (
					<>
						{address.city}, {address.zip}
					</>
				) : (
					<>
						{address.zip}, {address.city}, {address.customerCountry}
					</>
				)}
			</p>
		</>
	)
}
export default UserAddressInfo
